
import Vue from 'vue'
import Component from 'vue-class-component'
import { Toast } from 'vant'
import { Mixins } from 'vue-property-decorator'
import { getUrlArg } from '@space/utils'
import MechanismHeader from '@/components/MechanismHeader.vue'
import jzMechanism from './jzMechanism.vue'

@Component({
  components: { MechanismHeader, jzMechanism },
})
export default class IndexView extends Vue {
  active = getUrlArg('active') || '1'
  async created() {
    // await this.checkStatus()
    // this.result.tradeType = '337658'
  }
}
